<template>
  <div class="answer-detail js-answer-detail">
    <mobileHeader
      :alwaysShow="true"
      :goBack="navGoback"
      :customBackgroundColor="isSticky ? '#fff' : 'transparent'"
      borderBottom="0 none"
      class="header"
      :rightTxt="true"
      :rightFun="() => {}"
      v-if="$platform.isYixinliApp"
    >
      <div class="header-content" slot="navTitle">
        <div class="flex-box">
          <div class="head-l" @click="navGoback">
            <img class="back-btn" src="~images/qa/anwser/page-top-arrow.png" />
          </div>
          <div class="header-m" v-if="isSticky && isShow">
            <focusOnBar
              :author="{
                id: authUser.id,
                name: authUser.nickname,
                url: authUser.avatar,
                brief: authUser.brief,
                hasFollowed: pageData.isFollow
              }"
              :detail="{
                userIdentifyVoList: pageData.userIdentifyVoList,
                userLevel: pageData.userLevel
              }"
              @update="fetchAnswerDetail"
              @beforeToUser="beforeToUser"
              @afterToggleFollow="afterToggleFollow"
            />
          </div>
        </div>
        <div class="header-r" v-if="hasInfo">
          <img
            @click="handleShare"
            class="share-btn"
            src="~images/qa/anwser/page-top-more.png"
          />
        </div>
      </div>
    </mobileHeader>

    <swiperHead
      v-if="!$platform.isYixinliApp"
      errUrl="https://sdata.xinli001.com/t/5s"
    ></swiperHead>

    <!-- 渐变色底图，先隐藏，后续需要再放出来 -->
    <img
      src="~images/qa/anwser/page-top-bg.png"
      alt=""
      class="top-bg"
      v-if="0"
    />

    <div class="no-data" v-if="!hasInfo">
      <van-empty
        class="van-empty-wrp"
        description="该问题/回答已被删除"
        :image="require('images/platform/common-empty.png')"
      ></van-empty>
      <div class="btn-list">
        <div class="btn zan" @click="toQaIndex">去首页</div>
      </div>
    </div>

    <template v-else>
      <div class="pd32 z2">
        <a :href="questionDetailUrl">
          <div class="question-wrap">
            <h1 class="question-title" v-html="parsedTitle"></h1>
            <div
              class="question-info"
              v-if="question.commentnum > 0 || question.follownum > 0"
            >
              <a v-if="question.commentnum > 0" class="answer-num"
                >{{ question.commentnum }}个回答</a
              >

              <span v-if="question.commentnum > 0 && question.follownum > 0"
                >&nbsp;·&nbsp;</span
              >

              <span v-if="question.follownum > 0"
                >{{ question.follownum }}人关注</span
              >

              <img src="~images/qa/anwser/question-more.png" alt="" />
            </div>
          </div>
        </a>

        <focusOnBar
          :author="{
            id: authUser.id,
            name: authUser.nickname,
            url: authUser.avatar,
            brief: authUser.brief,
            hasFollowed: pageData.isFollow
          }"
          :detail="{
            userIdentifyVoList: pageData.userIdentifyVoList,
            userLevel: pageData.userLevel
          }"
          @update="fetchAnswerDetail"
          @beforeToUser="beforeToUser"
          @afterToggleFollow="afterToggleFollow"
        />

        <div class="answer-content" v-html="lineDecode(pageData.content)"></div>

        <!-- 咨询师、倾诉师卡片 -->
        <teacherCard
          :teacherInfo="teacherInfo"
          @seeCard="seeCard"
          v-if="isConsultOrQingsuTeacher"
        />

        <div class="btn-list" v-if="isShow">
          <div class="btn zan" @click="reward" v-if="article_reward_switch">
            赞赏
          </div>
          <div
            class="btn next"
            :class="{
              width100: !article_reward_switch,
              gay: !pageData.nextAnswerId
            }"
            @click="toNext"
          >
            {{ pageData.nextAnswerId > 0 ? '下一条回答' : '已是最后一个回答' }}
          </div>
        </div>

        <div class="reward-list" v-if="+rewardData.reward_number > 0">
          <ul>
            <li v-for="user in rewardData.reward_user_list" :key="user.id">
              <img :src="`${user.avatar}!80`" :alt="user.nickname" />
            </li>
          </ul>
          <div class="reward-number">
            {{ `等${rewardData.reward_number || 0}人打赏了作者` }}
          </div>
        </div>
      </div>

      <!-- 答主不是倾诉师或咨询师,推荐相关老师 -->
      <template v-if="!isQingting && !teacherInfo.consultTeacher">
        <div
          class="gray-line"
          v-if="teacherListAb.length > 0 || qingtingList.length > 0"
        ></div>
        <!-- 相关咨询师推荐， 咨询目标用户 -->
        <teacherItem
          :list="teacherListAb"
          @seeOne="seeOne"
          @seeMore="seeMore"
          v-if="isConsultTarget && teacherListAb.length > 0"
        />
        <!-- 相关倾听师推荐，非咨询目标用户 -->
        <qingsuTeacherItem
          :list="qingtingList"
          @seeOne="seeOneqingting"
          @seeMore="seeMoreQingsu"
          v-if="!isConsultTarget && qingtingList.length > 0"
        />
      </template>

      <!-- 群组推荐 -->
      <template v-if="similarGroupList && similarGroupList.length">
        <div class="gray-line"></div>
        <recommedGroup :list="similarGroupList" />
      </template>

      <div class="pd32">
        <!-- 评论列表 -->
        <commentList :teacherListAbInited="teacherListAbInited" />
      </div>

      <answerRewardForm
        :objectId="String(pageData.id)"
        :rewardNum="rewardData.reward_number"
        @update="fetchAnswerDetail"
        ref="rewardDialog"
      />

      <!-- 咨询师或倾听师卡片。  -->
      <TeacherCardPopupWrapper
        v-if="isConsultOrQingsuTeacher"
        :class="{ 'is-not-app': !$platform.isYixinliApp }"
        :delay="$platform.isYixinliApp ? 10 : 5"
        :detail="{
          ...pageData,
          contentType: 3
        }"
        :teacherInfo="teacherInfo"
        :channelFlag="'Platform_content_QA'"
      />

      <qaCommonAd v-if="renderQaCommonAd"></qaCommonAd>

      <!-- 站外固定底部 -->
      <fixedBottom v-if="showFixedBottom" />
    </template>
    <poster ref="poster" @getImgUrl="getImgUrl" v-if="$platform.isYixinliApp" />
  </div>
</template>

<script>
import closePreWebviewMixin from 'mixins/platfrom/closePreWebviewMixin.js'
import focusOnBar from 'component/qa/answer/focusOnBar.vue'
import mobileHeader from 'component/qa/MobileHeader'
import teacherCard from 'component/qa/answer/teacherCard.vue'
import answerRewardForm from 'component/qa/answer/answerRewardForm.vue'
import answerDetailStore from 'store/qa/answerDetail.js'
import qaQuestionDetailStore from 'store/qa/questionDetail.js'
import teacherItem from 'component/qa/answer/teacherItem.vue'
import qingsuTeacherItem from 'component/qa/answer/qingsuTeacherItem.vue'
import TeacherCardPopupWrapper from 'component/article/teacherCardPopupWrapper.vue'
import commentList from 'component/qa/answer/commentList'
import { getTeacherListAb, getTeacherInfo } from 'api/article'
import { increaseInvite } from 'api/qa/index.js'
import { commonGetToken } from 'utils/tool.js'
import { versionfunegt } from 'lib/tools/utils'
import wechatShareMixin from 'lib/mixins/wechatShare'
import { Empty } from 'vant'
import fixedBottom from 'component/qa/answer/fixedBottom.vue'
import { parseParamId } from 'utils/index.js'
import swiperHead from 'component/qa/swiperHead.vue'
import qaCommonAd from 'component/qa/qaCommonAd.vue'
import recommedGroup from 'component/qa/questions/recommedGroup.vue'
import poster from 'component/qa/questions/poster.vue'

export default {
  dataStore: [answerDetailStore, qaQuestionDetailStore],
  mixins: [wechatShareMixin, closePreWebviewMixin],
  components: {
    qaCommonAd,
    swiperHead,
    [Empty.name]: Empty,
    teacherItem,
    answerRewardForm,
    teacherCard,
    mobileHeader,
    focusOnBar,
    TeacherCardPopupWrapper,
    commentList,
    fixedBottom,
    qingsuTeacherItem,
    recommedGroup,
    poster
  },
  async preFetch({ store, route }) {
    return Promise.all([
      store.dispatch('qaAnswerDetail/fetchQaAnswerDetail', {
        id: parseParamId(route.params.id)
      }),
      store.state.platform?.isYixinliApp
        ? store.dispatch('qaQuestionDetail/fetchPosterShareData', {
            objectType: 3,
            objectId: parseParamId(route.params.id)
          })
        : Promise.resolve()
    ])
      .then(([res]) => {
        const { code, data } = res
        if (code === 0) {
          const { majorTitle = '', title = '' } = data.question
          store.commit('setMeta', {
            title: `${majorTitle || title}-壹心理`,
            keywords: `心理问答,心理社区`,
            description: `壹心理心理问答社区，为您知道了关于【${
              majorTitle || title
            }】的相关心理问答，心理问答社区是免费心理咨询解答平台，已有100多万人在此寻求心理问题帮助。`
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  data() {
    return {
      renderQaCommonAd: false,
      isSticky: false,
      teacherListAb: [],
      teacherListAbInited: false,
      teacherInfo: {},
      isShow: false,
      posterImg: ''
    }
  },
  computed: {
    answerId() {
      const id = this.$route.params.id
      return parseParamId(id)
    },
    hasInfo() {
      return this.pageData && Object.keys(this.pageData).length > 0
    },
    pageData() {
      return this.$store.state.qaAnswerDetail.detail
    },
    parsedTitle() {
      const { majorTitle = '', title = '' } = this.question
      return majorTitle || title
    },
    question() {
      return this.$store.getters['qaAnswerDetail/question']
    },
    authUser() {
      return this.$store.getters['qaAnswerDetail/authUser']
    },
    isOnwer() {
      const user = this.$store.state.userinfo
      return user && user.id == this.authUser.id
    },
    zixunTagIds() {
      const { zixunTagShotList } = this.pageData
      const tags = Array.isArray(zixunTagShotList) ? zixunTagShotList : []
      return tags.map(tag => tag.customeTagId).join(',')
    },
    wxfetchParams() {
      return {
        name: 'yida'
      }
    },
    shareConfig() {
      if (this.$isServer) return {}
      const { env } = this.$runningEnv
      const s = env ? `-${env}` : ''
      const link = `https://m${s}.xinli001.xin/qa/answer-${this.answerId}?is_share=1&node=1`

      const shareData = this.pageData.shareData || {}
      const { shareTitle, shareDesc, shareCover } = shareData
      const parsedTitle = `${this.authUser.nickname}回答了${shareTitle}`
      return {
        title: parsedTitle || '壹心理-人生答疑馆',
        desc: shareDesc,
        imgUrl: shareCover,
        link
      }
    },
    is_sshzv() {
      return +this.$route.query.sshzv === 1
    },
    questionTags() {
      const { parentTagNames, tagNames, dimensionTagNames } = this.question
      return {
        first_class: parentTagNames || [], //问题一级标签
        second_class: tagNames || [], //问题二级标签
        filter_item_Platform: dimensionTagNames || [] //问题平台维度
      }
    },
    authUserStatus() {
      return this.teacherInfo.consultTeacher
        ? ['咨询师']
        : this.teacherInfo.qingsuTeacher
        ? ['倾听师']
        : []
    },
    // 打赏数据
    rewardData() {
      const { rewardRoles, rewardUserList } = this.pageData
      const list = rewardUserList || []
      return {
        reward_switch: rewardRoles,
        reward_number: list.length,
        reward_user_list: list.slice(0, 6)
      }
    },
    article_reward_switch() {
      let isIos = this.$platform.isiPhone || this.$platform.isiPad
      let isApp = this.$platform.isYixinliApp
      if (isIos && isApp && this.is_sshzv) {
        // 新增
        return false
      } else {
        return this.rewardData.reward_switch
      }
    },
    isConsultOrQingsuTeacher() {
      return this.teacherInfo.consultTeacher || this.teacherInfo.qingsuTeacher
    },
    showFixedBottom() {
      // if (this.$isServer) return false
      const { yixinliAPPVersion, isYixinliApp } = this.$platform
      if (isYixinliApp && versionfunegt(yixinliAPPVersion, '8.5.15')) {
        return false
      } else {
        return true
      }
    },
    questionDetailUrl() {
      const { env } = this.$runningEnv
      const s = env ? `-${env}` : ''
      return `https://m${s}.xinli001.com/qa/${this.question.id}`
    },

    // 是否咨询目标用户
    isConsultTarget() {
      return +this.pageData?.isConsultTarget === 1 || false
    },
    // 答主是否倾诉师 1是
    isQingting() {
      return +this.pageData?.isQingTing === 1 || false
    },
    similarGroupList() {
      return this.$store.state.qaAnswerDetail?.answerSimilarGroupList || []
    },
    qingtingList() {
      return this.$store.state.qaAnswerDetail.qingtingList || []
    }
  },
  created() {
    if (this.$isServer) return

    window.baseInfo = {
      token: '',
      answer_id: this.answerId
    }
    this.$store
      .dispatch('getUserInfo')
      .then(res => {
        window.baseInfo.token = res.token
        window.baseInfo.userId = res.id
        window.baseInfo.authuser_id = this.authUser.id
      })
      .catch(err => {
        console.log(err)
      })
    this.showNativeBottomBar()

    Promise.all([this.fetchAnswerDetail(), this._getTeacherInfo()]).then(() => {
      const { isQingting, teacherInfo, isConsultTarget } = this
      if (!isQingting && !teacherInfo.consultTeacher) {
        if (isConsultTarget) {
          this._getTeacherListAb()
        } else {
          this._fetchQingtingList()
        }
      }
      this.$trackPageView('qa_answer_details_view', {
        ...this.questionTags,
        answer_id: this.answerId, //回答ID
        qa_id: this.question.id, //问题ID
        respondent_id: this.authUser.id, //答主id
        respondent_status: this.authUserStatus, //答主身份
        is_offer: !!this.article_reward_switch, //是否悬赏
        commend_business_type: isConsultTarget ? ['咨询'] : ['倾诉']
      })
    })
    setTimeout(() => {
      this.renderQaCommonAd = true // 广告弹窗不需要立刻弹窗，延迟一点加载
    }, 500)
  },
  mounted() {
    this.$store.dispatch('qaAnswerDetail/fetchAnswerSimilarGroup', {
      answerId: this.answerId,
      pageSize: 3
    })

    this.isShow = true
    if (this.$platform.isYixinliApp) {
      this.$bridge.call('switchNavigationBar', {
        isHidden: 1
      })
    }
    this.handlePoster()
    window.generateAndSharePoster = this.handleShare // 给客户端点击底部分享调用
    window.addEventListener('scroll', this.watchTop)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.watchTop)
  },
  methods: {
    lineDecode(input) {
      return input.replace(/\n/g, '</br>')
    },
    watchTop() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 40) {
        this.isSticky = true
      } else {
        this.isSticky = false
      }
    },
    reward() {
      this.$trackEvent('qa_answer_details_operation', {
        ...this.questionTags,
        answer_id: this.answerId, //回答ID
        qa_id: this.question.id, //问题ID
        respondent_id: this.authUser.id, //答主id
        respondent_status: this.authUserStatus, //答主身份
        operation_type: '发起打赏'
      })
      if (this.$platform.isWechat && this.$platform.isiPhone) {
        this.$toast('微信不支持苹果手机用户打赏', 2000)
        return
      }
      let userInfo = this.$store.state.userinfo
      if (userInfo && userInfo.token) {
        this.$refs.rewardDialog.openDialog()
      } else {
        this.toLogin()
      }
    },
    // 显示底部框
    showNativeBottomBar() {
      // app8.5.15及其以上，显示固底
      const { yixinliAPPVersion } = this.$platform
      if (versionfunegt(yixinliAPPVersion, '8.5.15') && this.hasInfo) {
        this.$bridge.call('isShowNativeBottomBar', {
          isShowed: true,
          objectId: window.baseInfo.answer_id,
          objectType: 3
        })
      }
    },
    beforeToUser() {
      this.$trackEvent('qa_answer_details_operation', {
        ...this.questionTags,
        answer_id: this.answerId, //回答ID
        qa_id: this.question.id, //问题ID
        respondent_id: this.authUser.id, //答主id
        respondent_status: this.authUserStatus, //答主身份
        operation_type: '查看作者'
      })
    },
    afterToggleFollow(isFollow) {
      this.$trackEvent('qa_answer_details_interaction', {
        ...this.questionTags,
        answer_id: this.answerId, //回答ID
        qa_id: this.question.id, //问题ID
        respondent_id: this.authUser.id, //答主id
        respondent_status: this.authUserStatus, //答主身份
        interaction_type: isFollow ? '关注' : '取消关注'
      })
    },
    seeOne(id, index) {
      this.$trackEvent('qa_answer_details_psychologist', {
        ...this.questionTags,
        answer_id: this.answerId, //回答ID
        qa_id: this.question.id, //问题ID
        respondent_id: this.authUser.id, //答主id
        item_location: index,
        psychologist_id: id
      })
    },
    seeOneqingting(id, index) {
      this.$trackEvent('qa_answer_details_listener', {
        ...this.questionTags,
        answer_id: this.answerId, //回答ID
        qa_id: this.question.id, //问题ID
        respondent_id: this.authUser.id, //答主id
        item_location: index,
        psychologist_id: id,
        listener_id: id
      })
    },
    seeMore() {
      this.$trackEvent('qa_answer_details_psychologist_more', {
        ...this.questionTags,
        answer_id: this.answerId, //回答ID
        qa_id: this.question.id, //问题ID
        respondent_id: this.authUser.id //答主id
      })
    },
    seeMoreQingsu() {
      this.$trackEvent('qa_answer_details_listener_more', {
        ...this.questionTags,
        answer_id: this.answerId, //回答ID
        qa_id: this.question.id, //问题ID
        respondent_id: this.authUser.id //答主id
      })
    },
    seeCard() {
      this.$trackEvent('qa_answer_details_card', {
        ...this.questionTags,
        answer_id: this.answerId, //回答ID
        qa_id: this.question.id, //问题ID
        respondent_id: this.authUser.id, //答主id
        respondent_status: this.authUserStatus
      })
    },
    fetchAnswerDetail() {
      return commonGetToken(this)
        .then(token => {
          return this.$store.dispatch('qaAnswerDetail/fetchQaAnswerDetail', {
            id: this.answerId,
            token
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取推荐咨询师列表
    _getTeacherListAb() {
      return getTeacherListAb({
        tag: this.zixunTagIds,
        size: 3
      })
        .then(res => {
          if (+res.code === 0) {
            this.teacherListAb = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.teacherListAbInited = true
        })
    },
    // 获取老师身份信息
    _getTeacherInfo() {
      if (!this.authUser.id) return
      getTeacherInfo({
        userId: this.authUser.id
      }).then(res => {
        if (+res.code === 0) {
          this.teacherInfo = res.data || {}
        }
      })
    },
    navGoback() {
      this.routerGoback()
    },
    async handleShare() {
      if (this.$platform.isYixinliApp) {
        let loading = null
        if (loading) return
        if (!this.posterImg) {
          loading = this.$loading(`加载中`)
          try {
            await this.$refs.poster.initPoster('isLoading')
            loading.close()
          } catch (err) {
            if (loading) {
              loading.close()
            }
          } finally {
            if (loading) {
              loading.close()
            }
          }
        }
        this.$bridge.shareReport({
          ...this.shareConfig,
          shareType: 'twoStepShare',
          bannerUrl: this.posterImg,
          isShowReport: this.isOnwer ? 0 : 1, // 是否显示举报
          newObjectType: 3, // 业务类型：回答
          object_id: this.answerId,
          sourcePage: '回答详情页',
          itemName: '回答详情链接',
          success: () => {
            this.shareSuccessFn()
            this.$trackEvent('qa_answer_details_operation', {
              ...this.questionTags,
              answer_id: this.answerId, //回答ID
              qa_id: this.question.id, //问题ID
              respondent_id: this.authUser.id, //答主id
              respondent_status: this.authUserStatus, //答主身份
              operation_type: '发起分享'
            })
          }
        })
      }
    },
    shareSuccessFn() {
      return increaseInvite().then(res => {
        if (+res.code === 0) {
          console.log('分享成功')
        }
      })
    },
    // toQuestion() {
    //   if (this.$platform.isYixinliApp) {
    //     this.routerPush({
    //       path: `/qa/${this.question.id}`
    //     })
    //   } else {
    // const { env } = this.$runningEnv
    // const s = env ? `-${env}` : ''
    // window.location.href = `https://m${s}.xinli001.com/qa/${this.question.id}`
    //   }
    // },
    toQaIndex() {
      const { env } = this.$runningEnv
      const s = env ? `-${env}` : ''
      this.routerPush(`https://m${s}.xinli001.com/qa`)
    },
    toNext() {
      const { nextAnswerId } = this.pageData
      if (nextAnswerId > 0) {
        this.$trackEvent('qa_answer_details_next', {
          ...this.questionTags,
          answer_id: this.answerId, //回答ID
          qa_id: this.question.id //问题ID
        })
        if (this.$platform.isYixinliApp) {
          this.routerPush({
            path: `/qa/answer-${nextAnswerId}`,
            query: {
              hideNavigationBar: 1,
              node: 1,
              closePre: 1
            }
          })
        } else {
          const { env } = this.$runningEnv
          const s = env ? `-${env}` : ''
          window.location.href = `https://m${s}.xinli001.com/qa/answer-${nextAnswerId}?node=1`
        }
      } else {
        this.$toast('已是最后一个回答')
      }
    },
    _fetchQingtingList() {
      const { categoryIdList = [] } = this.pageData
      this.$store.dispatch('qaAnswerDetail/fetchQingtingList', {
        page: 1,
        size: 3,
        category: Array.isArray(categoryIdList)
          ? categoryIdList.map(v => v).join(',')
          : ''
      })
    },
    async handlePoster() {
      // await this.$store.dispatch('qaQuestionDetail/fetchPosterShareData', {
      //   objectType: 3,
      //   objectId: this.answerId
      // })
      await this.$refs.poster.initPoster()
    },
    getImgUrl(url) {
      this.posterImg = url
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions.scss';
::v-deep .van-empty__image {
  height: auto !important;
}
::v-deep .is-not-app.teacher-card-popup-wrapper .popup-mask {
  padding-bottom: 160px !important;
}
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  .van-empty-wrp {
    margin-top: 120px;
    position: relative;
    z-index: 2;
    padding-bottom: 40px;
  }
}
::v-deep .head-middle {
  height: 100% !important;
}
::v-deep .header-left,
::v-deep .header-right {
  display: none !important;
}
.header-content {
  height: 100%;
  color: initial;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  box-sizing: border-box;
  .back-btn {
    width: 18px;
    height: 34px;
  }
  .share-btn {
    width: 36px;
    height: 36px;
  }
  .head-l {
    display: flex;
    align-items: center;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .header-r {
    display: flex;
    align-items: center;
  }
}

.flex-box {
  display: flex;
  align-items: center;
  flex: 1;
}

::v-deep .header-m {
  height: 88px;
  flex: 1;
  .qa-answer-focus-on-bar {
    height: 100%;
    padding: 0 !important;
    background-color: transparent !important;
    margin-left: 16px !important;
    .wrapper {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      height: 100%;
    }
    .user-name-inner {
      max-width: 160px !important;
    }
    .focus-on-button {
      margin-left: 0 !important;
    }
    .level-text.normal-info {
      max-width: 340px;
    }
  }
}

.answer-detail {
  background-color: #fff;
  box-sizing: border-box;
  min-height: 100vh;
  padding-bottom: 128px;
  .top-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 216px;
    z-index: 1;
  }
  .pd32 {
    padding: 0 32px;
  }
  .z2 {
    z-index: 2;
    position: relative;
  }
  .header-img {
    width: 44px;
    height: 44px;
  }
  .question-wrap {
    display: block;
    .question-title {
      font-size: 48px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #21252d;
      line-height: 72px;
      margin-top: 24px;
      word-break: normal;
      text-align: justify;
      @include limitLine(2);
    }
    .question-info {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9da3ac;
      display: flex;
      align-items: center;
      margin-top: 10px;
      img {
        width: 14px;
        height: 14px;
        margin-left: 10px;
      }
      .answer-num {
        color: #9da3ac;
      }
    }
  }
  .answer-content {
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6c798c;
    line-height: 49px;
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: justify;
  }
  .btn-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    .btn {
      width: 327px;
      height: 86px;
      background: #f3fbff;
      border-radius: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      font-weight: 600;
      &.zan {
        color: #6982fa;
      }
      &.next {
        color: #21252d;
        font-weight: 400;
      }
    }
    .width100 {
      width: 100%;
    }
    .gay {
      background-color: #f2f6fc !important;
      color: #6c798c !important;
    }
  }
  .reward-list {
    display: flex;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 60px;
    margin-left: 20px;
    > ul {
      display: flex;
      align-items: center;
      > li {
        border: 2px solid #ffffff;
        border-radius: 50%;
        margin-left: -14px;
        > img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
        }
      }
    }
  }
  .reward-number {
    margin-left: 10px;
    font-size: 24px;
    font-weight: 400;
    color: #9da3ac;
  }
  .gray-line {
    width: 750px;
    height: 20px;
    background: #f2f4ff;
  }
}
</style>
